<template>
  <div class="match-tabs">
    <div class="tab-bar">
      <div
        v-for="tab in tabs"
        :key="tab.routeName"
        class="tab-item"
        :class="{ active: isActive(tab) }"
        @click="goTab(tab)"
      >
        {{ tab.label }}
      </div>
    </div>
    <div class="tab-content">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'UaFlagMatch',
  data() {
    return {
      tabs: [
        { label: '积分榜', routeName: 'UaFlagStandings', path: 'standings' },
        { label: '赛程榜', routeName: 'UaFlagSchedule', path: 'schedule' },
        { label: '球员榜', routeName: 'UaFlagPlayerList', path: 'player-list' },
        { label: '球队数据', routeName: 'UaFlagTeamData', path: 'team-data' }
      ]
    }
  },
  computed: {
    matchId() {
      return this.$route.params.matchId
    }
  },
  methods: {
    isActive(tab) {
      return this.$route.name === tab.routeName
    },
    goTab(tab) {
      if (!this.matchId) return
      this.$router.replace({
        name: tab.routeName,
        params: { matchId: this.matchId }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.match-tabs {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #000;
}

.tab-bar {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-shrink: 0;
  padding: 10px 8px 12px;
  background: #dc0019;
  box-sizing: border-box;
}

.tab-item {
  flex: 1;
  text-align: center;
  font-size: 14px;
  color: #fff;
  padding: 6px 10px;
  border-radius: 20px;
  white-space: nowrap;
  cursor: pointer;
  box-sizing: border-box;
  max-width: 25%;

  &.active {
    background: rgba(0, 0, 0, 0.22);
    font-weight: 600;
  }
}

.tab-content {
  flex: 1;
  overflow: auto;
}
</style>
